import { ReactiveVar } from "@apollo/client";

import { useQueryParam, StringParam } from "use-query-params";

export function useReactiveQueryParam(
  name: string,
  reactiveVariable: ReactiveVar<string | null | undefined>
) {
  const [queryValue, setQueryValue] = useQueryParam(name, StringParam);
  // const reactiveVariable = makeVar(queryValue);
  return function v(params?: any) {
    if (arguments.length) {
      setQueryValue(params);
      return reactiveVariable(params);
    }
    if (queryValue !== reactiveVariable()) {
      reactiveVariable(queryValue);
    }
    return reactiveVariable();
  };
}

// export const useQueryParam = <D, D2 = D>(
//     name: string,
//     paramConfig: QueryParamConfig<D, D2> = StringParam as QueryParamConfig<any>
//   ): [D2, (newValue: NewValueType<D>, updateType?: UrlUpdateType) => void] => {
// };
